import { Matrix } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ResizeConnectorItemCommand from '../command/resizeConnectorItemCommand';
import ConnectorItem from '../item/connectorItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class ConnectorWidthField
 */
export default class ConnectorWidthField extends LengthUnitField {
    type = 'connectorWidth';

    /**
     * Update field value with item value.
     *
     * @param {ItemInterface} item
     */
    updateValue(item) {
        this.setValue(item.get('line').getLength());
    }

    /**
     * Update item value with field value.
     *
     * @param {ItemInterface} item
     * @param {number} difference (optional)
     */
    updateItem(item, difference) {
        const width = this.getValue() + difference || this.getValue();
        const line = item.get('line').clone();
        const matrix = new Matrix();
        const history = this.editor.getCanvas().getHistory();

        matrix.rotate(line.getAngle(), line.startPoint.x, line.startPoint.y);
        matrix.translate(width, 0);

        line.endPoint = line.startPoint.clone().transform(matrix);
        item.validateLine(line);
        this.updateValue(item);

        history.addAndExecuteCommand(new ResizeConnectorItemCommand(item, line));
    }

    /**
     * Update item value with field value relative to a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        this.updateItem(item, difference);
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1 && item instanceof ConnectorItem;
    }
}
